import React from 'react'

class ProgressBarMultiDoc extends React.Component{
    constructor(props){
        super(props)
    }
    render(){
        const{progressVal, status, className} = this.props

        let color='loading';
        if (status == 'finish') {
            color='completed'
        }else if (status=='failed') {
            color= 'failed'
        }

        return(
    		<div className={`progress progress-striped active progress-upload ${className}`}>
                <div className={`progress-bar-upload ${color}`} style={{width: `${progressVal}%`}}></div>
            </div>
        )
    }
}

export default ProgressBarMultiDoc